import React, { Component } from 'react';
import passed from '../../../../assets/img/performances/PASSED_GREEN@2x.png';

class PerformanceBarPrize extends Component {
  constructor(props) {
    super(props);

    const { incentive } = props;
    const progress = Math.min(Math.floor((incentive.packs_sold / incentive.target) * 100), 100);
    const baseTargetProgress = this.incentiveIsBaseTarget()
      ? Math.min(Math.floor((incentive.base_target / incentive.target) * 100), 100)
      : 0;

    let target1;
    let target2;

    if (this.incentiveIsBaseTarget()) {
      target1 = incentive.base_target;
      target2 = incentive.target;
    } else if (this.incentiveIsFixedTarget()) {
      target1 = incentive.target_1;
      target2 = incentive.target_2;
    } else if (this.incentiveIsPacksSold()) {
      target2 = incentive.target;
    }

    this.state = {
      target1,
      target2,
      baseTargetProgress,
      progress,
    };
  }

  componentDidMount() {
    this.updateCssVars();
  }

  updateCssVars() {
    const { incentive } = this.props;
    if (!this.refs[`performanceBarRef${incentive.id}`]) return;
    this._performanceBarElement = this.refs[`performanceBarRef${incentive.id}`];

    this._performanceBarElement.style.setProperty('--progress', `${this.state.progress || 0}%`);
    this._performanceBarElement.style.setProperty('--performance-bar-bg-color', this.performanceBarBGColor());
    this._performanceBarElement.style.setProperty('--target1-progress', `${this.state.baseTargetProgress || 0}%`);
    this._performanceBarElement.style.setProperty('--performance-base-target-bar-bg-color', this.performanceBarBGColor());
    this._performanceBarElement.style.setProperty('--performance-bar-overlay-progress', `${100 - (this.state.progress || 0)}%`);
  }

  hasReachedTarget() {
    const { incentive } = this.props;

    return incentive.packs_sold >= incentive.target
  }

  hasReachedBaseTarget() {
    const { incentive } = this.props;

    return incentive.packs_sold >= incentive.base_target
  }

  performanceBarBGColor() {
    if (this.hasReachedTarget()) {
      return '#70bd4d';
    }

    return '#ffc734';
  }

  performanceBaseTargetBarBGColor() {
    if (this.hasReachedBaseTarget()) {
      return '#70bd4d';
    }

    return '#ffc734';
  }

  incentiveIsPacksSold = () => {
      const { incentive } = this.props;

      return incentive.kind === 'packs_sold';
  }

  incentiveIsFixedTarget = () => {
      const { incentive } = this.props;

      return incentive.kind === 'fixed_target';
  }

  incentiveIsBaseTarget = () => {
    const { incentive } = this.props;

    return incentive.kind === 'base_target';
  }

  render() {
    const { incentive } = this.props;
    const performanceBarRef = `performanceBarRef${incentive.id}`;

    return (
      <div ref={performanceBarRef} className="performance-bar-wrapper performance-prize-wrapper">
        <div>
          {!this.hasReachedTarget() && (
            <div className="sold-indicator sold-indicator-progress">
              <strong>{incentive.packs_sold}</strong>
              <span className="glyphicon glyphicon-triangle-bottom" aria-hidden="true"></span>
            </div>
          )}
          <div className="performance-bar-back prize-wrapper"></div>
          <div className="performance-bar prize-wrapper performance-bar-background-color"></div>
          {this.incentiveIsBaseTarget() && (
            <div className="performance-bar performance-bar-progress"></div>
          )}
          <div className="performance-bar-overlay prize-wrapper performance-bar-overlay-progress"></div>
        </div>
        <div className='prize-container'>
            <div className='prize'>
              <img className={`prize-image ${this.hasReachedTarget() ? 'won' : ''}`} src={incentive.prize_image}/>
            </div>
          {this.hasReachedTarget() && (
            <div className="prize-won">
              <div className="prize-won-image-container">
                <img src={passed} />
              </div>
            </div>
          )}
          <div>
            <div  className={`target-label-container ${this.hasReachedTarget() ? 'won' : ''}`}>
              <div className="target-label">Target</div>
              <div className="target-value"><strong>{this.state.target2}</strong></div>
            </div>
            {(this.incentiveIsBaseTarget() || this.incentiveIsFixedTarget()) && (
              <div  className={`target-label-container ${this.hasReachedTarget() ? 'won' : ''}`}>
                <div className="target-label">Target</div>
                <div className="target-value"><strong className="target-value-color">{this.state.target1}</strong></div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default PerformanceBarPrize;



// WEBPACK FOOTER //
// ./src/components/common/store-performances/performance-bar/performance-bar-prize.jsx